export default __webpack_public_path__ + "static/media/vas-client-junction.483b404c.yaml";